export default "./dist/stdassets/images/icons/pan-west.png";